import * as actionTypes from 'constants/ActionTypes';

const cargoTagsCategories = (state = {
    items: [],
    isLoaded: false,
}, action) => {
    switch (action.type) {
    case actionTypes.GET_CARGO_TAGS_CATEGORIES.REQUEST:
        return {
            ...state,
            isLoaded: false,
        };
    case actionTypes.GET_CARGO_TAGS_CATEGORIES.SUCCESS: {
        const items = action.data.map(item => ({
            ...item,
            isUpdate: false,
        }));
        return {
            ...state,
            items,
            isLoaded: true,
        };
    }
    case actionTypes.GET_CARGO_TAGS_CATEGORIES.FAILURE:
        return {
            ...state,
            isLoaded: true,
        };
    default:
        return state;
    }
};

export default cargoTagsCategories;



// WEBPACK FOOTER //
// ./app/reducers/cargoes/tags.js